/**
 * Get the dimensions of an element
 * @param {string} element - The element to get the dimensions of
 * @returns {DOMRect} - The bounding client rect of the element
 */
function getElementDimensions(element) {

  const elementDom = document.querySelector(element);
  return elementDom.getBoundingClientRect();
}

class HeaderElement extends HTMLElement {
  #lastScrollPosition = window.scrollY;

  connectedCallback() {
    this.#getHeaderHeight();
    this.#handleScroll();

    window.addEventListener('resize', this.#getHeaderHeight, { passive: true });
    window.addEventListener('scroll', this.#handleScroll, { passive: true });
  }

  /**
   * Set header height in global scope and CSS var
   */
  #getHeaderHeight = () => {
    const headerHeight = getElementDimensions('header-element').height;
    window.HEADER_HEIGHT = headerHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  };

  /**
   * Handle scroll event
   */
  #handleScroll = () => {
    const currentScrollPosition = window.scrollY;

    if (currentScrollPosition <= window.HEADER_HEIGHT) {
      this.classList.remove('scrolled');
      this.#lastScrollPosition = currentScrollPosition;
      return;
    }

    if (currentScrollPosition > this.#lastScrollPosition) {
      this.classList.add('scrolled');
    }

    this.#lastScrollPosition = currentScrollPosition;
  };
}

customElements.define('header-element', HeaderElement);
